export default __webpack_public_path__ + "static/media/arrow-down.f7174313.svg";